import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './RegistrationCarousel.scss';
import accoladeLogo from '../../assets/Logo-Accolade-light.svg';
import languageIcon from '../../assets/icons/language-icon-white.svg';
import carouselImage1 from '../../assets/backgroundImages/registrationCarousel/carousel-image-1.jpg';
import carouselImage2 from '../../assets/backgroundImages/registrationCarousel/carousel-image-2.jpg';
import carouselImage3 from '../../assets/backgroundImages/registrationCarousel/carousel-image-3.jpg';
import carouselImage4 from '../../assets/backgroundImages/registrationCarousel/carousel-image-4.jpg';

import { useNavigate } from 'react-router-dom';

interface CarouselSlide {
  image: string;
  headline: string;
  subtext: string;
}

const slides: CarouselSlide[] = [
  {
    image: carouselImage1,
    headline: 'slide1.headline',
    subtext: 'slide1.subtext',
  },
  {
    image: carouselImage2,
    headline: 'slide2.headline',
    subtext: 'slide2.subtext',
  },
  {
    image: carouselImage3,
    headline: 'slide3.headline',
    subtext: 'slide3.subtext',
  },
  {
    image: carouselImage4,
    headline: 'slide4.headline',
    subtext: 'slide4.subtext',
  },
];

export const RegistrationCarousel: React.FC = () => {
  const { t, i18n } = useTranslation('auth');

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      if (currentSlide === slides.length - 1) {
        navigate('/register');
      } else {
        setCurrentSlide(currentSlide + 1);
      }
    }, 5000);

    return () => clearInterval(timer);
  }, [currentSlide, navigate]);

  const handlePrevious = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleNext = () => {
    if (currentSlide === slides.length - 1) {
      navigate('/register');
    } else {
      setCurrentSlide(currentSlide + 1);
    }
  };

  return (
    <div className="registration-carousel">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`registration-carousel__slide ${index === currentSlide ? 'active' : ''}`}
          style={{ 
            backgroundImage: `url(${slide.image})`,
            opacity: index === currentSlide ? 1 : 0,
            zIndex: index === currentSlide ? 1 : 0
          }}
        >
          <div className="registration-carousel__overlay">
            <button
              className="language-toggle"
              onClick={toggleLanguage}
              aria-label={t('nav.changeLanguage')}
            >
              <img src={languageIcon} alt="" />
              <span>{i18n.language.toUpperCase()}</span>
            </button>
            <header className="registration-carousel__header">
              <p className="welcomeText">{t('authPage.welcomeTo')}</p>
              <img src={accoladeLogo} alt={t('altText.accoladeLogo')} className="accoladeLogo" />
            </header>

            <div className="registration-carousel__content">
              <h2 className="registration-carousel__headline">
                {t(slide.headline)}
              </h2>
              <p className="registration-carousel__subtext">
                {t(slide.subtext)}
              </p>
            </div>

            <div className="registration-carousel__navigation">
              <button 
                className="registration-carousel__nav-button previous"
                onClick={handlePrevious}
                disabled={currentSlide === 0}
                aria-label={t('carousel.previous')}
              >
                ←
              </button>

              <button 
                className="registration-carousel__nav-button next"
                onClick={handleNext}
                aria-label={t('carousel.next')}
              >
                →
              </button>
            </div>

            <div className="registration-carousel__footer">
              <button 
                className="registration-carousel__skip"
                onClick={() => navigate('/register')}
              >
                {t('carousel.skip')}
              </button>

              <div className="registration-carousel__indicators">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    className={`registration-carousel__indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(index)}
                    aria-label={t('carousel.goToSlide', { number: index + 1 })}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
